export default __webpack_public_path__ + "static/media/projectNavIcon-color.47c7a4dd.svg";